<template>
	<table class="items-table" :class="{ active: true }" > <!-- :class="{ active: areDetailsShown }" -->
		<tbody>
			<tr>
				<td>
					<abbr title="Index Number"> {{ idx + 1 }} </abbr>
				</td>
				<td>
					<abbr title="Internal Item ID">{{ this.itemData.itemserial }}</abbr>
				</td>
				<td>
					<abbr title="External Item ID">{{ this.itemData.external_ref }}</abbr>
				</td>
				<td>
					<abbr title="Product SKU / Size">{{ this.itemData.sku }} / {{ this.itemData.size }}</abbr>
				</td>
				<td>
					<abbr title="Product Name">{{ this.itemData.pname }}</abbr>
				</td>
				<td>
					<abbr title="QTY">{{ this.itemData.quantity }}</abbr>
				</td>
				<td>
					<abbr title="Hours Counter">SLA: {{ this.itemData.sla }}</abbr>
				</td>
				<td colspan=2>
					<abbr title="Internal Status">{{ this.itemData.track }}</abbr>
				</td>
				<!-- <td>
					<abbr title="External Status">Create</abbr>
				</td> -->
				<!--
				<td>
					<div class="pdf-dw-btn">
						<a href="" target="_blank" class="pdf-dw-btn__link"></a>
					</div>
				</td>-->
			</tr>
		</tbody>
	</table>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "ItemsTable",
	components: {},
	props: {
		areDetailsShown: {
			type: Boolean
		},
		itemData: {
			type: Object 
		},
		idx: {
			type: Number
		} 
	}
});
</script>

<style lang="scss" scoped>
.items-table {
	display: none;

	&.active {
		display: block;
	}
	td {
		background-color: $color9;
		border: 1px solid $border-color;
		border-top: none;
		height: 30px;

		text-transform: uppercase;
		text-align: center;
		font-weight: 400;
		font-size: 11px;
	}
	td:nth-child(1) {
		width: 131px;
	}
	td:nth-child(2) {
		width: 91px;
	}
	td:nth-child(3) {
		width: 130px;
	}
	td:nth-child(4) {
		width: 215px;
	}
	td:nth-child(5) {
		width: 286px;
	}
	td:nth-child(6) {
		width: 185px;
	}
	td:nth-child(7) {
		width: 122px;
	}
	td:nth-child(8) {
		width: 157px;
	}
	td:nth-child(9) {
		/* width: 88px;*/
		border-left: 1px solid $border-color;
		width: 31px;
	}
	td:nth-child(10) {
		border-left: 1px solid $border-color;
		width: 31px;
	}
}

.pdf-dw-btn {
	display: flex;
	justify-content: center;
	align-items: center;

	&__link {
		display: inline-block;
		height: 21px;
		width: 21px;

		background-image: url("../../assets/pdf-file2.svg");
		background-repeat: no-repeat;
		background-position: center;
		background-color: $table-light-bg;
		background-size: 16px;

		border: 1px solid $border-color;
		border-radius: 5px;
	}
}
</style>